var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersondefaultreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#person_default_react_svg__clip0_2089_31890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a1 1 0 00-1 1v.5c0 .911.155 1.604.382 2.03.207.388.412.47.618.47.206 0 .41-.082.617-.47.227-.426.382-1.118.382-2.03V3a1 1 0 00-1-1zM5 3a3 3 0 116 0v.5c0 1.089-.179 2.146-.618 2.97C9.922 7.333 9.127 8 8 8c-1.127 0-1.923-.668-2.383-1.53C5.177 5.647 5 4.59 5 3.5V3zm-2.805 7.685c.622-1.038 1.659-2.042 3.234-2.042.293 0 .543.1.68.16.143.063.295.144.418.21l.017.009c.479.256.92.478 1.456.478.536 0 .977-.221 1.456-.478l.017-.01c.122-.065.275-.147.419-.21.136-.06.386-.16.68-.16 1.575.002 2.611 1.006 3.233 2.044.62 1.033.94 2.261 1.086 3.16.203 1.245-.819 2.154-1.89 2.154H3c-1.073 0-2.094-.909-1.892-2.154.146-.899.467-2.128 1.086-3.16zM3.112 14h9.776c-.134-.736-.391-1.606-.798-2.286-.412-.686-.876-1.031-1.422-1.068a2.78 2.78 0 00-.09.044l-.178.095-.033.018c-.469.251-1.3.697-2.367.697-1.068 0-1.898-.446-2.368-.697-.01-.007-.022-.013-.033-.018l-.178-.095a2.698 2.698 0 00-.09-.044c-.546.036-1.01.38-1.42 1.067-.408.68-.665 1.55-.8 2.287z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "person_default_react_svg__clip0_2089_31890"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgPersondefaultreact;